export interface ToolExecutionContext {
  // Extend as needed (e.g., auth tokens, services)
  sessionId?: string;
}

export type ToolExecutor = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  args: Record<string, any>,
  context: ToolExecutionContext
) => Promise<string>;

export interface ToolRegistry {
  getExecutor(toolName: string): ToolExecutor | undefined;
}

export class SimpleToolRegistry implements ToolRegistry {
  private readonly nameToExecutor = new Map<string, ToolExecutor>();

  register(toolName: string, executor: ToolExecutor): void {
    this.nameToExecutor.set(toolName, executor);
  }

  getExecutor(toolName: string): ToolExecutor | undefined {
    return this.nameToExecutor.get(toolName);
  }
}
